import { render, staticRenderFns } from "./DirectInterpreterSection.vue?vue&type=template&id=3b37e281&scoped=true&"
import script from "./DirectInterpreterSection.vue?vue&type=script&lang=js&"
export * from "./DirectInterpreterSection.vue?vue&type=script&lang=js&"
import style0 from "./DirectInterpreterSection.vue?vue&type=style&index=0&id=3b37e281&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37e281",
  null
  
)

export default component.exports